import { createBehavior } from '@area17/a17-behaviors';
import * as FocusTrap from 'focus-trap';
import onClickOutside from '../utils/onClickOutside';

const dropdown = createBehavior(
  'dropdown',
  {
    open() {
      this.isOpen = true;
      this.render();
    },
    close() {
      this.isOpen = false;
      this.render();
    },
    handleBtnClick() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    render() {
      if (this.isOpen) {
        this.$plusIcon.setAttribute('hidden', '');
        this.$minusIcon.removeAttribute('hidden');
        this.$panel.removeAttribute('aria-hidden');
        this.$node.setAttribute('role', 'dialog');
        this.$btnLabel.setAttribute('aria-label', 'Close panel');
        this.$panel.inert = false;
        setTimeout(() => {
          this.focusTrap.activate();
        }, 0);
        this.$node.classList.add('dropdown:is-open');
        setTimeout(() => {
          this.onClickOutside = new onClickOutside(this.$panel, () => {
            this.close();
          });
        }, 0);
      } else {
        this.$plusIcon.removeAttribute('hidden');
        this.$minusIcon.setAttribute('hidden', '');
        this.$panel.setAttribute('aria-hidden', 'true');
        this.$node.removeAttribute('role');
        this.$btnLabel.removeAttribute('aria-label');
        this.focusTrap.deactivate();
        this.$panel.inert = true;
        this.$node.classList.remove('dropdown:is-open');
        if (this.onClickOutside) {
          this.onClickOutside.remove();
        }
      }
    },
  },
  {
    init() {
      this.$plusIcon = this.getChild('plus-icon');
      this.$minusIcon = this.getChild('minus-icon');
      this.$btn = this.getChild('btn');
      this.$btnLabel = this.getChild('btn-label');
      this.$panel = this.getChild('panel');

      this.$btn.addEventListener('click', this.handleBtnClick);

      this.$panel.inert = true;

      this.focusTrap = FocusTrap.createFocusTrap(this.$node, {
        allowOutsideClick: true,
        onActivate: () => {},
        onDeactivate: () => {
          if (this.isOpen) {
            this.close();
          }
        },
      });
    },
  }
);

export default dropdown;
